import React, { useState } from "react";
import { CircularProgress, Fade, TextField, Modal, Typography } from '@mui/material';
import { AiOutlinePlus } from "react-icons/ai";
import { addSociete } from "../../../../services/SocieteService";
import { AppButton } from "../../../../components/UI";

const paperStyle = {
  backgroundColor: '#fff',
  boxShadow: '0 20px 60px rgba(0,0,0,0.12)',
  padding: '24px 32px',
  borderRadius: '16px',
  minWidth: '360px',
  maxWidth: '95vw',
  outline: 'none',
};

export default function SocieteModal({ errors, setErrors, snackbarShowMessage, societeData, setEmployeur }) {
  const [open, setOpen] = useState(false);
  const [newEmployeur, setNewEmployeur] = useState("");
  const [loading, setLoading] = useState(false);

  const validate = () => {
    let temp = {};
    temp.newEmloyeur = newEmployeur ? "" : "Le champ 'NOM SOCIÉTÉ' est obligatoire.";
    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    if (loading) return;
    setOpen(false);
  };

  const handleChange = (e) => setNewEmployeur(e.target.value.toUpperCase());

  const handleSubmit = () => {
    if (validate()) {
      (async () => {
        setLoading(true);
        const societe = {
          nom_societe: newEmployeur, n_tel: "", adresse: "", code_postal: "", ville: "",
          siteinternet: "", sachez_que: "", description_societe: "", actualite_societe: "",
          statut: "client", effectif: "", type_societe: "", secteur_dactivite: "",
          region_societe: "", linkedin: "", localisation: "",
        };
        try {
          const response = await addSociete(societe);
          snackbarShowMessage("La société a été ajoutée avec sucèss.", "success");
          setLoading(false);
          const newSociete = { uuid: response.data.newSocieteUuid, nomSociete: newEmployeur, secteur: null, type: null };
          societeData.data.push(newSociete);
          setEmployeur(newSociete);
          handleClose();
        } catch (error) {
          snackbarShowMessage(`Erreur d'ajout de la société "${newEmployeur}". veuillez réessayer plus tard`, "error");
          setLoading(false);
        }
      })();
    }
  };

  const body = (
    <div style={paperStyle}>
      <div className="modal-header" style={{ borderBottom: '1px solid #f1f5f9', paddingBottom: '12px', marginBottom: '16px' }}>
        <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: '#0f172a', fontFamily: "'Fira Sans', sans-serif" }}>
          Ajouter une société
        </Typography>
      </div>
      <div className="modal-body">
        <label className="input-label" htmlFor="newEmployeur">
          NOM SOCIÉTÉ <span className="required-input">*</span>
        </label>
        <TextField
          id="newEmployeur"
          name="newEmployeur"
          value={newEmployeur}
          onChange={handleChange}
          placeholder="Nom de l'employeur."
          margin="normal"
          variant="outlined"
          autoComplete="off"
          fullWidth
          {...(errors.newEmloyeur && { error: true, label: errors.newEmloyeur })}
        />
      </div>
      <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', borderTop: '1px solid #f1f5f9', paddingTop: '16px', marginTop: '16px' }}>
        <AppButton variant="secondary" onClick={handleClose} disabled={loading}>
          Annuler
        </AppButton>
        <AppButton variant="primary" onClick={handleSubmit} loading={loading}>
          Sauvegarder
        </AppButton>
      </div>
    </div>
  );

  return (
    <>
      <button className="btn btn-sm btn-link float-right" style={{ textDecoration: "none" }} onClick={handleOpen}>
        <AiOutlinePlus style={{ fontWeight: 500, marginBottom: "0.2em" }} />
        Ajouter
      </button>
      <Modal
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        open={open}
        onClose={handleClose}
        closeAfterTransition
      >
        <Fade in={open}>{body}</Fade>
      </Modal>
    </>
  );
}
